import api from '../utils/apiUtils';

const productData = [
  {
    id: 1,
    type: 'premium-upgrade',
    title: 'Upgrade to Premium',
    description: 'Unlock the full Waves Within experience with unlimited access to our complete mantra library, exclusive meditations, and premium features.',
    price: '$19.99/month',
    features: [
      'Complete mantra library access',
      'Exclusive sleep meditations',
      'Ad-free experience',
      'Offline downloads',
      'Premium chakra visualizations',
      'Priority customer support'
    ],
    cta: 'Upgrade Now',
    image: '/images/premium-upgrade.jpg', // placeholder
    popular: true
  },
  {
    id: 2,
    type: 'gift-premium',
    title: 'Gift Premium Membership',
    description: 'Share the gift of inner peace and wellness with someone special. Perfect for birthdays, holidays, or just because.',
    price: 'Starting at $19.99',
    features: [
      'Choose 1, 3, 6, or 12 months',
      'Personalized gift message',
      'Beautiful digital gift certificate',
      'Instant or scheduled delivery',
      'Full premium access for recipient'
    ],
    cta: 'Send Gift',
    image: '/images/gift-premium.jpg', // placeholder
    popular: false
  },
  {
    id: 3,
    type: 'personalized-mantra',
    title: 'Personalized Mantra Creation',
    description: 'Work with our experienced practitioners to create a completely personalized mantra tailored to your unique intentions and goals.',
    price: '$89.99',
    features: [
      '30-minute consultation call',
      'Custom mantra creation',
      'Professional audio recording',
      'Written intention guide',
      'Follow-up session included',
      'Unlimited revisions'
    ],
    cta: 'Customize',
    image: '/images/personalized-mantra.jpg', // placeholder
    popular: false,
    deliveryTime: '7-10 business days'
  },
  {
    id: 4,
    type: 'ebooks',
    title: 'Wellness eBooks Collection',
    description: 'Deepen your practice with our curated collection of digital wellness guides, meditation techniques, and spiritual wisdom.',
    price: 'Starting at $9.99',
    cta: 'Browse Collection',
    image: '/images/ebooks-collection.jpg', // placeholder
    popular: false,
    ebooks: [
      {
        id: 'eb1',
        title: 'Ocean Meditation: A Complete Guide',
        price: '$12.99',
        pages: 45,
        description: 'Master the art of ocean-inspired meditation with this comprehensive guide.',
        preview: '/pdfs/ocean-meditation-preview.pdf'
      },
      {
        id: 'eb2',
        title: 'Chakra Healing with Sound',
        price: '$15.99',
        pages: 62,
        description: 'Learn how to balance your chakras using sound healing techniques.',
        preview: '/pdfs/chakra-sound-preview.pdf'
      },
      {
        id: 'eb3',
        title: 'Creating Sacred Space at Home',
        price: '$9.99',
        pages: 38,
        description: 'Transform your home into a sanctuary for spiritual practice.',
        preview: '/pdfs/sacred-space-preview.pdf'
      },
      {
        id: 'eb4',
        title: 'Mantra Magic: Ancient Wisdom for Modern Life',
        price: '$18.99',
        pages: 78,
        description: 'Discover the transformative power of mantras in daily life.',
        preview: '/pdfs/mantra-magic-preview.pdf'
      },
      {
        id: 'eb5',
        title: 'Sleep Soundly: Natural Rest Techniques',
        price: '$11.99',
        pages: 42,
        description: 'Achieve deeper, more restorative sleep naturally.',
        preview: '/pdfs/sleep-soundly-preview.pdf'
      }
    ]
  },
  {
    id: 5,
    type: 'sound-healing',
    title: '1:1 Sound Healing Session',
    description: 'Experience the profound healing power of personalized sound therapy with our certified practitioners.',
    price: '$125.00',
    features: [
      '60-minute virtual session',
      'Personalized sound healing',
      'Crystal bowl therapy',
      'Chakra balancing',
      'Take-home recording',
      'Integration guidance'
    ],
    cta: 'Book Session',
    image: '/images/sound-healing.jpg', // placeholder
    popular: true,
    availability: 'Available 7 days a week',
    practitioners: [
      {
        name: 'Sarah Ocean',
        specialty: 'Crystal Bowl Healing',
        experience: '8 years',
        image: '/images/practitioner-sarah.jpg'
      },
      {
        name: 'Michael Wave',
        specialty: 'Tibetan Sound Healing',
        experience: '12 years',
        image: '/images/practitioner-michael.jpg'
      },
      {
        name: 'Luna Tide',
        specialty: 'Voice & Mantra Healing',
        experience: '6 years',
        image: '/images/practitioner-luna.jpg'
      }
    ]
  }
];

// Sleep meditation data
const sleepMeditations = [
  
];

// Simulate API call - returns all products
export const fetchProducts = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(productData);
    }, 500);
  });
};

// Get featured sleep meditation
export const fetchFeaturedSleepMeditation = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const featured = sleepMeditations[Math.floor(Math.random() * sleepMeditations.length)];
      resolve(featured);
    }, 300);
  });
};

// Get all sleep meditations
export const fetchSleepMeditations = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(sleepMeditations);
    }, 400);
  });
};

// Get product by ID
export const fetchProductById = (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const product = productData.find(p => p.id === parseInt(id));
      if (product) {
        resolve(product);
      } else {
        reject(new Error('Product not found'));
      }
    }, 300);
  });
};

export const createCheckoutSession = async (priceId) => {
  const response = await api.post('/stripe/create-checkout-session', { priceId });
  return response.data; // should be { sessionId }
};

export const fetchPurchaseDetails = async (sessionId) => {
  // Dummy data for now; replace with axios/api call later
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        orderId: sessionId || 'ORDER12345',
        productName: 'Premium Upgrade',
        amount: '$19.99',
        email: 'user@email.com',
      });
    }, 500);
  });
}; 